export default function ({ ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <circle cx="14" cy="14.002" r="14" fill="white" fillOpacity="0.2" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.309 4.38576C12.968 3.95133 12.3393 3.87559 11.9049 4.2166C11.4705 4.55761 11.3947 5.18623 11.7357 5.62066L13.3733 7.70686C10.0073 7.88503 6.9901 10.195 6.07046 13.6272C4.92692 17.8949 7.45958 22.2816 11.7273 23.4252C15.995 24.5687 20.3817 22.036 21.5253 17.7683C21.9648 16.1278 21.8608 14.4668 21.323 12.9807C21.135 12.4614 20.5617 12.1928 20.0424 12.3807C19.523 12.5687 19.2544 13.142 19.4424 13.6614C19.8455 14.7751 19.9237 16.018 19.5934 17.2507C18.7358 20.4515 15.4457 22.351 12.2449 21.4933C9.04415 20.6357 7.14466 17.3456 8.00231 14.1448C8.71283 11.4931 11.0928 9.73452 13.7084 9.69687L11.7355 12.1365C11.3882 12.5659 11.4548 13.1956 11.8842 13.5429C12.3137 13.8901 12.9433 13.8235 13.2906 13.3941L16.3872 9.56508C16.6803 9.20256 16.6841 8.68555 16.3962 8.31882L13.309 4.38576Z"
                fill="white"
                fillOpacity="0.8"
            />
        </svg>
    );
}
